<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="故障"
      left-text=""
      right-text=""
      @click-left="onClickLeft"
    />
    <van-popup
      v-model="zshow"
      overlay-class="xlPopup"
      get-container="app-page"
      position="right"
      :style="{ width: '60%', margin: '23px 0 0 0', height: pageHeight + 'px' }"
    >
      <ul style="flex: 1; height: calc(100%-46px)" class="xlUl">
        <li
          v-for="(xlItem, index) in xlTree"
          :key="index"
          @click="toxlDiares(index)"
        >
          <span>{{ xlItem.label }}</span>
          <p>
            <span>行波模块：</span><i>{{ xlItem.kgDtu }}</i
            ><span>架空型：</span><i>{{ xlItem.jkDtu }}</i
            ><span>电缆型：</span><i>{{ xlItem.dlDtu }}</i>
          </p>
        </li>
      </ul>
    </van-popup>
    <!-- 下拉菜单 -->
    <van-dropdown-menu active-color="#0B7DEC">
      <van-dropdown-item :title="title1" ref="item1" @open="openMenu">
        <van-grid :border="false" :gutter="10" :column-num="4">
          <van-grid-item>
            <span
              :class="[{ onpick: eTarget === '全部' }, 'pickitem']"
              :style="{ 'pointer-events': canClick ? '' : 'none' }"
              @click="pickOption1($event)"
              >全部</span
            >
            <!-- <van-button size="small" plain hairline type="info">全部</van-button> -->
          </van-grid-item>
          <van-grid-item>
            <span
              :class="[{ onpick: eTarget === '近三月' }, 'pickitem']"
              :style="{ 'pointer-events': canClick ? '' : 'none' }"
              @click="pickOption1($event)"
              >近三月</span
            >
            <!-- <van-button type="default" size="small">近三月</van-button> -->
          </van-grid-item>
          <van-grid-item>
            <span
              :class="[{ onpick: eTarget === '近半年' }, 'pickitem']"
              :style="{ 'pointer-events': canClick ? '' : 'none' }"
              @click="pickOption1($event)"
              >近半年</span
            >
            <!-- <van-button type="default" size="small">近半年</van-button> -->
          </van-grid-item>
          <van-grid-item>
            <span
              :class="[{ onpick: eTarget === '近一年' }, 'pickitem']"
              :style="{ 'pointer-events': canClick ? '' : 'none' }"
              @click="pickOption1($event)"
              >近一年</span
            >
            <!-- <van-button type="default" size="small">近一年</van-button> -->
          </van-grid-item>
        </van-grid>

        <div class="datetimepicker">
          <p>自定义</p>
          <van-row
            gutter="0"
            type="flex"
            justify="center"
            :style="{
              'margin-bottom':
                !datapickershow1 || !datapickershow2 ? '20px' : '',
            }"
          >
            <van-col span="10">
              <input
                type="text"
                class="dateinput"
                readonly="readonly"
                placeholder="开始日期"
                v-model="startTimek"
                @click="datapicker1"
                @focus="startTimeFocus"
              />
            </van-col>
            <van-col span="4" style="color: #707070">-</van-col>
            <van-col span="10">
              <input
                type="text"
                class="dateinput"
                readonly="readonly"
                placeholder="结束日期"
                v-model="endTimek"
                @click="datapicker2"
                @focus="endTimeFocus"
              />
            </van-col>
            <!-- <van-calendar v-model="showCalendar" type="range" @confirm="onConfirm" color="#1989fa" title=""
            :poppable="false"
            :show-confirm="false" :style="{height:'350px'}"/> -->
          </van-row>
          <van-datetime-picker
            v-show="datapickershow1"
            :show-toolbar="false"
            v-model="startTime1"
            type="date"
            title="选择日期"
            :min-date="minDate"
            :max-date="maxDate"
            :visible-item-count="3"
            :formatter="formattterDatetime"
            @change="endTimeChange1"
          />
          <van-datetime-picker
            v-show="datapickershow2"
            :show-toolbar="false"
            v-model="endTime1"
            type="date"
            title="选择日期"
            :min-date="minDate"
            :max-date="maxDate"
            :visible-item-count="3"
            :formatter="formattterDatetime"
            @change="endTimeChange2"
          />
          <van-row gutter="0" type="flex" justify="center">
            <van-col span="12">
              <van-button type="info" class="btnitem" @click="sureDatetime"
                >确认</van-button
              >
            </van-col>
            <van-col span="12">
              <van-button
                color="#D2EAFB"
                type="info"
                class="btnitem reset"
                @click="resetDatetime"
                >重置</van-button
              >
            </van-col>
          </van-row>
        </div>
      </van-dropdown-item>
      <!-- <van-dropdown-item v-model="value1" :options="option1" /> -->
      <van-dropdown-item
        :title="title2"
        ref="item2"
        @open="openDropdown"
        class="dropmenu2"
      >
        <div class="app-page">
          <van-collapse
            v-model="activeNames"
            style="width: 100vw"
            @change="chageCollapse"
          >
            <van-collapse-item title="" :name="name">
              <template #title>
                <div style="padding-left: 5px">
                  <van-icon :name="isOn ? isOnsrc1 : isOnsrc2" size="17px" />
                  <span
                    :style="isOn ? 'color:#0B7DEC;' : 'color:#353535;'"
                    style="font-size: 16px; font-weight: bold"
                    >全部线路
                  </span>
                </div>
              </template>

              <div
                class="item-box"
                v-for="(item, index1) in listTree"
                :key="index1"
              >
                <div
                  :class="[
                    isExpanded && itemIndex == index1 ? 'expanded ' : '',
                    'item-name',
                  ]"
                  @click="itemSelect(index1)"
                >
                  <span
                    ><van-icon
                      :name="isExpanded && itemIndex == index1 ? src1 : src2"
                    />{{ item.label }}</span
                  >
                  <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
                </div>
                <div class="item-one" v-show="itemIndex == index1">
                  <div
                    class="item-one-child"
                    v-for="(oneItem, index2) in item.children"
                    :key="index2"
                  >
                    <div
                      :class="[
                        isExpanded2 && itemTwoIndex == index2
                          ? 'expanded '
                          : '',
                        'child-name',
                      ]"
                      @click="
                        itemTwoSelect(
                          index2,
                          oneItem.value,
                          item.value,
                          oneItem
                        )
                      "
                    >
                      <div
                        style="flex: 1"
                        :class="[
                          oneItem.value.indexOf('E') < 0 ? '' : 'flexClass',
                        ]"
                      >
                        <span>{{ oneItem.label }}</span>
                        <!-- <p><span>变电站：</span><i>{{ oneItem.count }}</i></p> -->
                        <p v-show="oneItem.value.indexOf('E') < 0">
                          <span>线路：</span><i>{{ oneItem.count }}</i>
                        </p>
                      </div>
                      <i
                        class="van-icon van-icon-arrow van-cell__right-icon"
                      ></i>
                    </div>
                    <div
                      class="item-two"
                      v-show="
                        itemTwoIndex == index2 &&
                        oneItem.value.indexOf('E') >= 0
                      "
                    >
                      <div
                        class="item-two-child"
                        v-for="(twoItem, index3) in oneItem.children"
                        :key="index3"
                      >
                        <div
                          :class="[
                            isExpanded3 && itemThreeIndex == index3
                              ? 'expanded '
                              : '',
                            'child-name',
                          ]"
                          @click="
                            itemThreeSelect(
                              index3,
                              twoItem.value,
                              oneItem.value
                            )
                          "
                        >
                          <div style="flex: 1">
                            <span>{{ twoItem.label }}</span>
                            <p>
                              <span>线路：</span><i>{{ twoItem.count }}</i>
                            </p>
                          </div>
                          <i
                            class="van-icon van-icon-arrow van-cell__right-icon"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </van-dropdown-item>

      <van-dropdown-item :title="title3" ref="item3">
        <ul class="gzdrop">
          <li>
            <span
              :class="[{ onpick: title3 === '全部故障类型' }, 'pickitem']"
              @click="pickOption3($event)"
              >全部</span
            >
          </li>
          <li>
            <span
              :class="[{ onpick: title3 === '接地' }, 'pickitem']"
              @click="pickOption3($event)"
              >接地</span
            >
          </li>
          <li>
            <span
              :class="[{ onpick: title3 === '速断' }, 'pickitem']"
              @click="pickOption3($event)"
              >速断</span
            >
          </li>
          <li>
            <span
              :class="[{ onpick: title3 === '过流' }, 'pickitem']"
              @click="pickOption3($event)"
              >过流</span
            >
          </li>
          <li>
            <span
              :class="[{ onpick: title3 === '瞬时性短路' }, 'pickitem']"
              @click="pickOption3($event)"
              >瞬时性短路</span
            >
          </li>
        </ul>
        <!-- <van-grid :border="false" :gutter="0" :column-num="5">
            <van-grid-item>
              <span :class="[{ onpick: title3==='全部故障类型' }, 'pickitem']" @click="pickOption3($event)">全部</span>
            </van-grid-item>
            <van-grid-item>
              <span :class="[{ onpick: title3==='接地' }, 'pickitem']" @click="pickOption3($event)">接地</span>
            </van-grid-item>
            <van-grid-item>
              <span :class="[{ onpick: title3==='速断' }, 'pickitem']" @click="pickOption3($event)">速断</span>
            </van-grid-item>
            <van-grid-item>
              <span :class="[{ onpick: title3==='过流' }, 'pickitem']" @click="pickOption3($event)">过流</span>
            </van-grid-item>
            <van-grid-item>
              <span :class="[{ onpick: title3==='瞬时性短路' }, 'pickitem']" @click="pickOption3($event)">瞬时性短路</span>
            </van-grid-item>
          </van-grid> -->
      </van-dropdown-item>
      <!-- <van-dropdown-item v-model="value2" :options="option2" /> -->
    </van-dropdown-menu>
    <div
      class="tj historyDiares"
      :style="{ height: pageHeight - 75 + 'px' }"
      ref="articleRef"
    >
      <van-pull-refresh
        v-model="isLoading"
        success-text="刷新成功"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishText"
          @load="onLoad"
          :offset="10"
          :immediate-check="false"
        >
          <van-empty description="没有数据啦~" v-show="nodataShow" />
          <!-- <p>刷新次数: {{ count }}</p> -->
          <ul>
            <li
              class="item xltj"
              v-for="(item, index) in list"
              :key="index"
              @click="tofaultDiares(index)"
            >
              <h3>
                <i
                  :style="
                    item.readType == 1
                      ? 'width:0px'
                      : item.readType == 2
                      ? 'background: #E85B45;width:9px'
                      : ''
                  "
                  v-show="item.readType == 1 ? false : true"
                ></i
                >{{ item.mlName }}-{{ item.diaTypeName
                }}<i class="van-icon van-icon-arrow van-cell__right-icon"></i>
              </h3>
              <p>{{ item.diaRemark }}</p>
              <!-- <van-button :color="item.fixedType == 0 ? '#F27A2B' :(item.fixedType==1?'#0BA57B':'')" plain size="mini"
              >{{item.fixedType == 0 ? '区间' : (item.fixedType==1?'精确':'')}}定位</van-button
            > -->
              <em>{{ item.fcreateTime }}</em>
            </li>

            <!-- <li class="item xltj">
            <h3>过流故障</h3>
            <p>
              2021/1/10 08:00:25xxxxx线路名称发生接地故障，故障区段在南湖支线#2与南湖支线#14之间。
            </p>
            <van-button color="#0BA57B" plain size="mini"
              >精确定位</van-button
            >
          </li> -->
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Icon,
  Grid,
  GridItem,
  DatetimePicker,
  Calendar,
  Collapse,
  CollapseItem,
  Popup,
  Overlay,
  Empty,
  Toast,
} from "vant";

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Icon,
  Grid,
  GridItem,
  DatetimePicker,
  Calendar,
  Collapse,
  CollapseItem,
  Popup,
  Overlay,
  Empty,
  Toast
);

export default {
  name: "faultPage",
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [DatetimePicker.name]: DatetimePicker,
    [Calendar.name]: Calendar,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Popup.name]: Popup,
    [Overlay.name]: Overlay,
    [Empty.name]: Empty,
    [Toast.name]: Toast,
  },
  data() {
    return {
      name: "1", // 折叠面板唯一标识符，默认为索引值
      nodataShow: false,
      finishText: "没有更多了",
      canClick: true, // 是否可选
      activeName: "111", // 折叠菜单默认展开(手风琴)
      datapickershow1: false,
      datapickershow2: false,
      count: 0,
      isLoading: false,
      loading: false,
      finished: false,

      total: "", // 总条数
      totalPage: "", // 总页数
      offset: 50, // 滚动条与底部距离小于 offset 时触发load事件
      currentPage: 1, // 当前页
      pagesize: 15, // 每页显示条数
      timeType: 3, // 1近3个月 2近半年 3近一年 4全部
      type: 4, // 故障类型 1接地故障 2速断故障 3过流故障 4全部
      mlineid: "", // 线路名称
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),

      startTimek: "", // 输入框开始时间
      endTimek: "", // 输入框结束时间
      startTime1: new Date(), // '20000225', // 参数开始时间 20210225
      endTime1: new Date(), // '20210321', // 参数截止时间 20210226
      list: [],
      title1: "近一年",
      title2: "全部线路",
      title3: "全部故障类型",
      value: 0,
      value1: 0,
      value2: "a",
      // minDate1: null,
      // minDate2: new Date(),
      // maxDate1: null,
      // maxDate2: new Date(),
      date: "",
      show: false,
      showCalendar: false,
      isOn: true,
      isOnsrc1: require("../assets/qbxl-on@3x.png"),
      isOnsrc2: require("../assets/qbxl@3x.png"),
      isExpanded: true,
      isExpanded2: true,
      isExpanded3: true,
      src1: require("../assets/xian-on@3x.png"),
      src2: require("../assets/xian@3x.png"),
      zshow: false,
      activeNames: ["1"],
      pageHeight: window.innerHeight - 46,
      xlTree: [],
      listTree: [],
      itemIndex: -1, // 0, // 默认展开第一层供电公司
      itemTwoIndex: -1, // 0 // 默认展开第一层供电所
      itemThreeIndex: 0,
      timeData: [],
      readIndex: "", // 点击列表下标
      scrollTop: 0, // 在data属性中记录滚动的距离
      eTarget: "近一年", // 第一项选择值
    };
  },
  created() {
    // console.log('created')
    this.currentPage = parseInt(localStorage.getItem("currentPage") || 1); // 缓存里取到的都是字符串，根据实际情况转换。不让刚才11这种情况就来了。 以前没有缓存过分页，默认使用1.。.存储当前页,, 你是憨批吗？？？？这tm是设置还是取值？。。。 取值tm也不该在这儿取啊
  },
  // 注意this.scrollTop是用户触发滚动事件获取的。
  activated() {
    // console.log('activated' + this.scrollTop)
    // console.log(this.scrollTop)
    this.$refs.articleRef.scrollTop = this.scrollTop;
    // console.log(this.readIndex)
    // console.log(this.list.length)
    if (this.list.length > 0) {
      this.list[this.readIndex].readType = 1; // 已点击的变为已读，隐藏未读标记
    }
  },
  mounted() {
    // console.log('mounted')
    this.getPassYearFormatDate();
    // this.startTimek = this.timeData[0]
    // this.endTimek = this.timeData[1]
    // this.startTime = this.startTimek.split('/').join('')
    // this.endTime = this.endTimek.split('/').join('')
    this.startTime = this.timeData[0].split("/").join("");
    this.endTime = this.timeData[1].split("/").join("");
    // this.startTime = this.startTimek.split('/').join('')
    // this.endTime = this.endTimek.split('/').join('')
    // 默认查询近1年的信息
    // this.getDiaresPage()
    // this.formattD()
    this.onRefresh();
    let article = this.$refs.articleRef; // 获取到根节点
    // 绑定onscroll事件，只要滚动鼠标就会触发该事件，记录滚动的值
    article.addEventListener("scroll", this.pageScroll, true);
  },
  methods: {
    pageScroll() {
      // console.log(this.$refs.articleRef.scrollTop) // 有用就怪了
      this.scrollTop = this.$refs.articleRef.scrollTop;
    },
    /* 获取过去时间，并传值给现在时间, 没用过moment是吗？时间格式换写 */
    getPassYearFormatDate() {
      var nowDate = new Date();
      var date = new Date(nowDate);
      date.setDate(date.getDate() - 365);
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var formatDate = year + seperator1 + month + seperator1 + strDate;
      this.getNowFormatDate(formatDate);
    },
    /* 获取现在时间，并接受过去时间的值 */
    getNowFormatDate(formatDate) {
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var nowData = year + seperator1 + month + seperator1 + strDate;
      this.timeData = [formatDate, nowData]; // 默认赋值一年时间
    },
    endTimeChange1(e) {
      // 起始时间输入框值变化时触发事件
      let endTimeArr = e.getValues(); // ["2019", "03", "22", "17", "28"]
      this.startTimek = `${endTimeArr[0]}/${endTimeArr[1]}/${endTimeArr[2]}`;
      // this.maxDate1 = new Date(this.endTimek)// 设置起始时间必须小于终止时间
      // this.minDate2 = new Date(this.startTimek)// 设置终止时间必须大于起止时间
      this.startTime = `${endTimeArr[0]}${endTimeArr[1]}${endTimeArr[2]}`;
      this.timeType = 4; // 时间变为全部
      // this.canClick = false
      //console.log(this.startTimek + "-" + this.endTimek);
      // this.title1 = this.startTimek + '-' + this.endTimek
    },
    endTimeChange2(e) {
      // 终止时间输入框值变化时触发事件,选择后上面的快捷选项不能选
      let endTimeArr = e.getValues(); // ["2019", "03", "22", "17", "28"]
      this.endTimek = `${endTimeArr[0]}/${endTimeArr[1]}/${endTimeArr[2]}`;
      this.endTime = `${endTimeArr[0]}${endTimeArr[1]}${endTimeArr[2]}`; // 请求接口参数

      this.timeType = 4; // 时间变为全部
      // this.canClick = false// 选择后上面的快捷选项不能选
      // this.title1 = this.startTimek + '-' + this.endTimek
    },
    openDropdown() {
      // 打开菜单栏时触发
      this.getMlineTree(); // 线路菜单
    },
    getMlineTree() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      // 线路菜单接口
      this.util.post("/getMlineTree").then(({ data }) => {
        if (data.code === 200) {
          this.listTree = data.data.listTree;
          // var xlIndex = this.xlIndex
          // this.mlineId = data.data.listTree[xlIndex].value
          Toast.clear(); // 手动清除 Toast
        } else {
          return Promise.reject(
            new Error(data.message || data.msg || "系统错误，请稍后再试。")
          );
        }
      });
    },
    onRefresh() {
      // console.log('onRefresh')
      // 清空列表数据
      this.currentPage = 1;
      this.list = [];
      this.finished = false;
      // this.isLoading = true//3.31改

      this.getDiaresPage();
      // this.onLoad()
    },
    onLoad() {
      // console.log('onload') // 加载下一页。
      if (!this.isLoading) {
        this.currentPage += 1;
        this.getDiaresPage();
      }
    },
    getDiaresPage() {
      // console.log('加载第：' + this.currentPage + '页的数据')

      localStorage.setItem("currentPage", this.currentPage); // 存储当前页
      let param = {};
      param.currentPage = this.currentPage;
      param.pagesize = this.pagesize; // 每页显示条数
      param.timeType = this.timeType; // 1近3个月 2近半年 3近一年 4全部
      param.type = this.type; // 故障类型 1接地故障 2速断故障 3过流故障 4全部
      param.mlineId = this.mlineid; // 线路名称
      param.startTime = this.startTime; // 开始时间 20210225
      param.endTime = this.endTime; // 截止时间 20210226
      // }
      // console.log(param.currentPage)
      // 故障分页信息接口
      this.util.post("/getDiaresPage", param).then(({ data }) => {
        if (data.code === 200) {
          // console.log(data)
          // this.util.toast(data.msg)
          // this.list = data.data.data.items
          this.total = data.data.total;
          this.totalPage = data.data.totalPage;

          let infolist = data.data.list;
          if (infolist.length > 0) {
            this.nodataShow = false;
          }

          // 数据全部加载完成
          if (infolist) {
            this.list = this.list.concat(infolist); //方向不要搞反了，否则连接顺序会错
            // 请在数据渲染完成后设置load状态。

            this.$nextTick(() => {
              this.loading = false; // 取消正在加载状态
              this.isLoading = false;
              // 不限制的concat， 人家刷新了，还在保留着以前的数据？
              //this.list = this.currentPage === 1 ? this.list : this.list.concat(infolist)
              if (this.currentPage < this.totalPage) {
                // 判断接口返回数据量小于请求数据量，则表示此为最后一页
                this.finished = false;
              } else {
                this.finished = true;
                if (this.list.length === 0) {
                  this.nodataShow = true;
                  this.finishText = "";
                } else {
                  this.nodataShow = false;
                  this.finishText = "没有更多了";
                }
              }
            });
          } else {
            this.loading = false; // 取消正在加载状态
            this.isLoading = false;
            this.finished = true;
          }
        } else {
          this.loading = false;
          this.isLoading = false;
          this.currentPage -= 1;
          return Promise.reject(
            new Error(data.message || data.msg || "系统错误，请稍后再试。")
          );
        }
      });
    },
    tofaultDiares(index) {
      console.log(index); // 点击的下标
      this.readIndex = index;

      // console.log(this.list)
      this.$router.push({
        path: "/faultDiaresPage",
        query: {
          acciId: this.list[index].acciId,
          mlineId: this.list[index].mlineId,
        }, // 跳转到故障详情页
      });
    },
    datapicker1() {
      this.datapickershow1 = true;
      this.datapickershow2 = false;
    },
    datapicker2() {
      this.datapickershow2 = true;
      this.datapickershow1 = false;
    },
    // 时间
    pickOption1(e) {
      // console.log(e.target.className)
      // this.title1 = e.target.innerHTML
      this.eTarget = e.target.innerHTML;
      // console.log(this.eTarget)
      this.startTimek = null;
      this.endTimek = null;

      if (e.target.innerHTML === "全部") {
        // timeType: '', // 1近3个月 2近半年 3近一年 4全部
        this.timeType = 4;
      } else if (e.target.innerHTML === "近三月") {
        this.timeType = 1;
      } else if (e.target.innerHTML === "近半年") {
        this.timeType = 2;
      } else if (e.target.innerHTML === "近一年") {
        this.timeType = 3;
      }
    },
    // // 线路
    // pickOption2 (e) {
    //   console.log(e.target.innerHTML)// 获取当前元素内容
    //   if (e.target.innerHTML === '全部线路') {
    //     this.title3 = '全部故障类型'
    //   } else {
    //     this.title3 = e.target.innerHTML
    //   }
    //   this.getDiaresPage()
    // },
    // 故障类型
    pickOption3(e) {
      if (e.target.innerHTML === "全部") {
        this.title3 = "全部故障类型";
      } else {
        this.title3 = e.target.innerHTML;
      }
      if (e.target.innerHTML === "全部") {
        // 1接地故障 2速断故障 3过流故障 4全部
        this.type = 4;
      } else if (e.target.innerHTML === "接地") {
        this.type = 1;
      } else if (e.target.innerHTML === "速断") {
        this.type = 2;
      } else if (e.target.innerHTML === "过流") {
        this.type = 3;
      } else if (e.target.innerHTML === "瞬时性短路") {
        this.type = 5;
      }
      // 清空数据
      this.list = [];
      this.currentPage = 1;
      this.getDiaresPage();
      this.$refs.item3.toggle();
    },
    // formatDate (date) {
    //   console.log(date.getYear())
    //   return `${date.getYear()}/${date.getMonth() + 1}<10?'0'+${date.getMonth() + 1}:${date.getMonth() + 1}/${date.getDate()}`
    // },
    onClickLeft() {
      // window.history.back()
      this.$router.go(-1); // 返回上一页面
    },
    // onConfirm () {
    //   this.$refs.item.toggle()
    // },
    // formatDate (date) {
    //   return `${date.getMonth() + 1}/${date.getDate()}`
    // },
    formattterDatetime(type, val) {
      // console.log(type)
      // console.log(val)
      if (type === "year") {
        return `${val}`;
      } else if (type === "month") {
        return `${val}`;
      } else {
        return `${val}`;
      }
      // return val
    },

    openMenu() {
      // 打开菜单栏时触发
      this.showCalendar = false;
    },
    sureDatetime() {
      console.log(this.startTimek);
      console.log(this.endTimek);
      // console.log(this.eTarget)
      // console.log(this.title1 = this.startTimek + '-' + this.endTimek)
      // this.startTime = this.formattD(this.startTime)
      // this.endTime = this.formattD(this.endTime)
      if (
        this.startTimek != null &&
        this.endTimek != null &&
        this.startTimek !== "" &&
        this.endTimek !== ""
      ) {
        this.startTime = this.startTimek.split("/").join("");
        this.endTime = this.endTimek.split("/").join("");
        this.eTarget = "";
        this.title1 = this.startTimek + "-" + this.endTimek;
      } else {
        this.startTime = null;
        this.endTime = null;
      }
      if (
        this.startTimek != null &&
        this.startTimek !== "" &&
        (this.endTimek == null || this.endTimek === "")
      ) {
        this.util.toast("结束日期不能为空");
        return;
      }
      if (
        (this.startTimek == null || this.startTimek === "") &&
        this.endTimek != null &&
        this.endTimek !== ""
      ) {
        this.util.toast("开始日期不能为空");
        return;
      }
      if (this.startTimek > this.endTimek) {
        this.util.toast("开始日期不能大于结束日期");
      } else {
        if (this.eTarget) {
          // console.log('wwwwwwwwwww')
          this.title1 = this.eTarget; // 点击确认以后才赋值title1
        }

        // 点击确认以后才赋值开始时间和结束时间
        // console.log(this.title1)
        // 清空数据
        this.list = [];
        this.currentPage = 1;
        this.getDiaresPage();
        this.zshow = false;
        this.$refs.item1.toggle();
      }
    },
    resetDatetime() {
      // '点击重置按钮时触发的事件'
      this.currentPage = 1;
      this.startTimek = "";
      this.endTimek = "";
      this.timeType = 3;
      this.eTarget = "近一年";
      this.canClick = true;
    },
    chageCollapse() {
      // this.activeNames = ['']
      this.title2 = "全部线路";
      this.isOn = true; // 全部线路为选中状态
      this.mlineid = "";
      this.name = "1";
      // this.itemIndex = '' // 0, // 默认展开第一层供电公司
      // this.itemTwoIndex = '' // 0 // 默认展开第一层供电所
      this.$refs.item2.toggle();
      // 其它线路移除选中状态
      this.isExpanded = false;
      this.itemIndex = -1;
      // 清空数据
      this.list = [];
      this.getDiaresPage();
    },
    toxlDiares: function (index) {
      this.xlIndex = index; // 点击线路的下标
      this.title2 = this.xlTree[index].label; // 选中线路名称
      this.zshow = false; // 关闭遮罩
      this.isOn = false; // 全部线路为未选中状态
      this.mlineid = this.xlTree[index].value;
      // 清空数据
      this.list = [];
      this.currentPage = 1;
      this.getDiaresPage();
    },
    // 第一层选择
    itemSelect: function (index1) {
      if (this.itemIndex === index1) {
        // 折叠
        this.isExpanded = false;
        this.itemIndex = -1;
      } else {
        // 展开
        this.isExpanded = true;
        this.itemIndex = index1;
      }
      this.itemTwoIndex = -1; // 复位第二层的选择状态
    },
    // 第二层选择
    itemTwoSelect: function (index2, stationId1, eleoffId, item) {
      if (
        item.children[0].children[0] &&
        item.children[0].children[0].children
      ) {
        //有4级
        if (this.itemTwoIndex === index2) {
          // 折叠
          this.isExpanded3 = false;
          this.itemTwoIndex = -1;
        } else {
          // 展开
          this.isExpanded3 = true;
          this.itemTwoIndex = index2;
        }
        this.itemThreeIndex = -1; // 复位第二层的选择状态
      } else {
        //没有第4级
        this.zshow = true; // 显示线路遮罩
        // 根据局id、变电站id获取线路接口
        this.util
          .post("/getMlineByEleoffIdAndStationId1", {
            eleoffId: eleoffId,
            stationId1: stationId1,
          })
          .then(({ data }) => {
            if (data.code === 200) {
              this.xlTree = data.data.listTree;
              // var xlIndex = this.xlIndex
              // this.mlineId = data.data.listTree[xlIndex].value
            } else {
              return Promise.reject(
                new Error(data.message || data.msg || "系统错误，请稍后再试。")
              );
            }
          });
      }
    },
    // 第三层
    itemThreeSelect: function (index3, stationId1, eleoffId) {
      this.zshow = true; // 显示线路遮罩
      // 根据局id、变电站id获取线路接口
      this.util
        .post("/getMlineByEleoffIdAndStationId1", {
          eleoffId: eleoffId,
          stationId1: stationId1,
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.xlTree = data.data.listTree;
            // var xlIndex = this.xlIndex
            // this.mlineId = data.data.listTree[xlIndex].value
          } else {
            return Promise.reject(
              new Error(data.message || data.msg || "系统错误，请稍后再试。")
            );
          }
        });
    },
    startTimeFocus(event){
      if (this.startTimek===null || this.startTimek===''){
        this.startTimek=this.getMaxDate()
      }
    },
     endTimeFocus(event){
      if (this.endTimek===null || this.endTimek===''){
        this.endTimek=this.getMaxDate()
      }
    },
    getMaxDate(){
      var date = new Date();
      var seperator1 = "/";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var nowData = year + seperator1 + month + seperator1 + strDate;
        return nowData;
    },
  },
  computed: {
    bcolor: function () {
      return this.coloritem;
    },
    // maxDate1: function () {
    //   let curDate = (new Date()).getTime()
    //   let one = 365 * 24 * 3600 * 1000
    //   let oneYear = curDate + one
    //   return new Date(oneYear)
    // },
    // maxDate2: function () {
    //   let curDate = (new Date()).getTime()
    //   let one = 365 * 24 * 3600 * 1000
    //   let oneYear = curDate + one
    //   return new Date(oneYear)
    // }
  },
};
</script>

<style scoped lang="less">
/deep/.van-dropdown-menu__bar {
  height: 34px;
}
/deep/.van-nav-bar__content {
  height: 46px;
  background: linear-gradient(227deg, #06c8b5 0%, #007cf8 100%);
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
/deep/.van-overlay {
  top: 46px;
  height: calc(100%-46px);
}
// /deep/.van-popup{
//   height: calc(100%-46px);
// }
/deep/.van-collapse-item__title > .van-cell__right-icon {
  color: #0b7dec;
}
/deep/.van-dropdown-menu__item {
  justify-content: end;
  padding: 0 10px;
  border-right: 1px solid #ebebeb;
}
/deep/.van-dropdown-menu__title {
  width: 25vw;
}
input.dateinput:focus {
  border: 1px solid#0B7DEC;
}
.item-box .van-cell__right-icon {
  height: 40px;
  line-height: 40px;
  margin-right: 16px;
}
.home {
  overflow-y: hidden;
  margin-top: 46px;
}
.historyDiares {
  overflow-y: auto;
}

.van-button {
  vertical-align: middle;
}
.xltj i:nth-of-type(1) {
  // width:9px;
  height: 9px;
  // background: #E85B45;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.xltj i:nth-of-type(2) {
  float: right;
}
.pickitem {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #d6d6d6;
  border-radius: 4px;
  color: #565656;
  font-size: 13px;
}
.pickitem.onpick {
  border: 1px solid #0b7dec;
  color: #0b7dec;
}
.item {
  padding: 12px 12px 20px !important;
}
.item em {
  float: right;
  color: #a2a1a0;
  font-size: 12px;
  margin-top: -2px;
  // margin-top: 3px;
}

.datetimepicker {
  padding: 0 12px 18px 12px;
  > p {
    margin-bottom: 10px;
  }
}
.datetimepicker .van-col {
  text-align: center;
}
.datetimepicker input {
  width: 40vw;
  background: #ebebeb;
  padding: 5px 10px;
  border: none;
  border-radius: 4px;
  text-align: center;
}
.btnitem {
  width: 40vw;
  height: 36px;
  font-size: 15px;
  border-radius: 4px;
}
.reset {
  color: #0b7dec !important;
}
/deep/.app-page .van-collapse-item__content {
  padding: 0px 0;
}
/deep/.dropmenu2 .van-dropdown-item__content {
  max-height: 100%;
  height: 100%;
}

.item-box .van-cell__right-icon {
  margin-right: 16px;
}
/deep/.van-collapse-item__title .van-cell__right-icon::before {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  -webkit-transition: -webkit-transform 0.3s;
  transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
  transition: transform 0.3s, -webkit-transform 0.3s;
}
/deep/.van-collapse-item__wrapper {
  height: 100% !important; // 让折叠菜单一直展开
  display: block !important; // 让折叠菜单一直展开
}
.item-name .van-cell__right-icon {
  height: 60px;
  line-height: 60px;
}
</style>
